import React from 'react'
import { Col, Form } from 'react-bootstrap';
import Select from "react-select";
import makeAnimated from "react-select/animated";

const MultiSelectComponent = ({
    label,
    options,
    value,
    onChange,
    placeholder ,
    isMulti = true,
    isDisabled = false,
    customStyles = {},
}) => {
    const animatedComponents = makeAnimated();
    const defaultStyles = {
        control: (provided) => ({
            ...provided,
            borderRadius: "4px",
            borderColor: "#ced4da",
        }),
    };
    return (
        <Col md={6} className='mb-3'>
            <Form.Label className="fw-semibold">{label}</Form.Label>
            <Select
                isMulti={isMulti}
                isDisabled={isDisabled}
                components={animatedComponents}
                options={options}
                value={value || []}
                onChange={onChange}
                placeholder={placeholder}
                styles={{ ...defaultStyles, ...customStyles }}
                closeMenuOnSelect={false}
                theme={(theme) => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary25: "#e9ecef",
                        primary: "#007bff",
                    },
                })}
            />
        </Col>
    )
}

export default MultiSelectComponent
